export default "__VITE_ASSET__BwUcWPP1__"